import styled from "styled-components";
import { HeaderActions } from "./components/showcase-display/ShowcaseDisplay.styles";

export const ShowcaseContainerContainer = styled.div`
    align-items: start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-between;

    ${HeaderActions} {
        opacity: 0;
        pointer-events: none;
    }

    &:hover ${HeaderActions} {
        opacity: 1;
        pointer-events: auto;
    }

    @media (hover: none) {
        ${HeaderActions} {
            opacity: 1;
            pointer-events: auto;
        }
    }
`